import {downloadFile, _delete} from './Tools';

const downloadTxt = async (periodo_id, formato_bancario_id, anio, numero_periodo) => {
  try {
    const response = await downloadFile(`${process.env.REACT_APP_SERVER}distribucion_bancaria/download?periodo_id=${periodo_id}&formato_bancario_id=${formato_bancario_id}&anio=${anio}&numero_periodo=${numero_periodo}`,);
    return response;
  } catch (error) {
    console.error('Error en la descarga:', error);
    return { ok: false, message: error.message };
  }
};

export { downloadTxt };